import { useCallback } from "react"
import { useMutation } from "react-relay"
import { graphql } from "relay-runtime"
import {
  DeleteAppointmentInput,
  useDeleteAppointmentMutation as deleteAppointmentMutation,
} from "@/modules/patients/services/__generated__/useDeleteAppointmentMutation.graphql"

const mutation = graphql`
  mutation useDeleteAppointmentMutation($deleteAppointment: DeleteAppointmentInput!, $connections: [ID!]!) {
    deleteAppointment(input: $deleteAppointment) {
      #missing: we must remove the corresponding edge/node
      appointment {
        id @deleteEdge(connections: $connections)
        appointmentId
      }
    }
  }
`

export function useDeleteAppointmentMutation() {
  const [commit] = useMutation<deleteAppointmentMutation>(mutation)

  return useCallback(
    (input: DeleteAppointmentInput, connections: string[], existingFollowUpForProgressNoteId?: string) => {
      commit({
        variables: {
          deleteAppointment: input,
          connections,
        },
        updater: (store, response) => {
          const data = response?.deleteAppointment
          if (data?.appointment && existingFollowUpForProgressNoteId) {
            const progressNoteProxy = store.get(existingFollowUpForProgressNoteId)
            progressNoteProxy?.setValue(null, "followUpAppointment")
          }
        },
      })
    },
    [commit],
  )
}
